<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="base-info group">
          <div class="basic">
            <!-- <span>*</span> -->
            基本信息
          </div>
          <el-form
            ref="form"
            :rules="rules"
            :model="info"
            class="good-form base-info-form"
            label-width="auto"
          >
            <el-form-item label="活动名称" prop="name" class="form-item">
              <el-input
                placeholder="请输入活动名称"
                v-model="info.name"
                class="good-input"
              ></el-input>
              <span class="tip">活动名称不要超过十六个字</span>
            </el-form-item>
            <el-form-item label="活动海报" class="form-item" prop="pic">
              <div class="addImg">
                <p class="tips">建议最小尺寸：730*260 ，注意保持长宽比</p>
                <div class="img-box">
                  <img ref="img" class="img" :src="info.pic" v-if="info.pic" />
                  <div class="icon" v-else>
                    <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                    <p>图片</p>
                    <p class="tip">支持扩展名：.jpg .png</p>
                  </div>
                  <input
                    type="file"
                    class="file"
                    ref="inputImg"
                    @change="addChangeImg"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="排序：" prop="twig" class="form-item">
              <el-input
                placeholder="请输入序号"
                class="good-input"
                style="width: 200px"
                v-model.number="info.twig"
                type="number"
                onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
              ></el-input>
              <span
                class="sort-tip"
                style="color: #C8C8C8;font-size: 14px;margin-left: 12px;"
                >数值越大，排序越靠前</span
              >
            </el-form-item>
            <el-form-item
              label=" "
              prop="sort"
              style="margin-top: 32px;"
              class="form-item"
            >
              <div class="btn" @click="addActivity">保存基本信息</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="base-info group" v-if="id">
          <div class="basic">
            <!-- <span>*</span> -->
            关联商品
          </div>
          <div class="filter-box">
            <div class="filter">
              <div class="filter-item">
                <div class="label">商品名称：</div>
                <el-input
                  class="input"
                  style="width: 248px;"
                  v-model="filter.name"
                  placeholder="请输入内容"
                  size="small"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="label">商品分区：</div>
                <el-select
                  placeholder="请选择"
                  v-model="filter.partition"
                  class="input"
                  size="small"
                  style="width: 248px"
                >
                  <el-option
                    v-for="item in businessList"
                    :key="item"
                    :value="item"
                    :label="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="label">商品分类：</div>
                <el-cascader
                  v-model="category2"
                  :options="categoryList"
                  placeholder="请选择"
                  size="small"
                  :props="{
                    children: 'second',
                    value: 'id',
                    label: 'name',
                    checkStrictly: true,
                  }"
                  class="input"
                  style="width: 248px"
                ></el-cascader>
              </div>
              <div class="btn-box">
                <button class="search" @click="search">筛选</button>
                <button class="reset" @click="reset">重置</button>
              </div>
            </div>
            <div class="btn-box">
              <button
                class="search"
                style="margin-left: 60px"
                @click="selectGoods"
              >
                + 添加关联商品
              </button>
            </div>
          </div>
          <el-table
            :data="list"
            class="table no-border-table"
            style="padding: 0 20px;"
            ref="table"
            :header-cell-style="{
              border: 'none',
              color: '#333',
              background: '#f6f6f6',
              borderBottom: '1px solid #E8E8E8',
              height: '54px',
            }"
            :row-style="{
              height: '54px',
            }"
          >
            <el-table-column
              type="index"
              :index="tableIndex"
              align="center"
              label="编号"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="id"
              align="center"
              label="商品ID"
            ></el-table-column>
            <el-table-column
              prop="name"
              align="center"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              prop="minPrice"
              align="center"
              label="价格"
            ></el-table-column>
            <el-table-column prop="status" align="center" label="状态">
              <div slot-scope="scope">
                {{ scope.row.status === 3 ? "出售中" : "仓库中" }}
              </div>
            </el-table-column>
            <el-table-column
              prop="totalStock"
              align="center"
              label="库存"
            ></el-table-column>
            <el-table-column prop="balance" align="center" label="所属分类">
              <div slot-scope="scope">
                {{ scope.row.firstSortName + "/" + scope.row.secondSortName }}
              </div>
            </el-table-column>
            <el-table-column prop="orderBy" align="center" label="排序">
              <div
                slot-scope="scope"
                style="text-decoration: underline;font-size: 14px;color: #FF7E90;cursor: pointer;"
                @click="changeSortModal(scope.row.activityTwig, scope.row.id)"
              >
                {{ scope.row.activityTwig }}
              </div>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <div
                slot-scope="scope"
                style="display: flex; justify-content: center"
              >
                <div style="display: flex; justify-content: center">
                  <button
                    size="mini"
                    class="table-btn"
                    @click="disassociationActivity(scope.row.id)"
                  >
                    取消关联
                  </button>
                </div>
              </div>
            </el-table-column>
          </el-table>
          <!-- 分页按钮 -->
          <!-- <div class="footer">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              background
              layout="total, prev, pager, next, jumper"
              :page-size="size"
              :total="total"
            ></el-pagination>
          </div> -->
        </div>

        <!-- <div class="btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div> -->
      </div>
    </div>
    <el-dialog title="添加活动关联商品" width="1000px" :visible.sync="visible">
      <div class="filter-box">
        <div class="filter">
          <div class="filter-item" style="margin-right: 10px;">
            <div class="label">商品分类：</div>
            <el-cascader
              v-model="category"
              :options="categoryList"
              placeholder="请选择"
              size="small"
              :props="{
                children: 'second',
                value: 'id',
                label: 'name',
                checkStrictly: true,
              }"
              class="good-input"
              style="width: 130px"
            ></el-cascader>
          </div>
          <div class="filter-item" style="margin-right: 10px;">
            <div class="label">商品分区：</div>
            <el-select
              placeholder="请选择"
              v-model="partition"
              class="good-input"
              size="small"
              style="width: 130px"
            >
              <el-option
                v-for="item in businessList"
                :key="item"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item" style="margin-right: 10px;">
            <div class="label">商品名称：</div>
            <el-input
              class="input"
              style="width: 130px"
              v-model="name"
              placeholder="请输入内容"
              size="small"
            ></el-input>
          </div>
        </div>
        <div class="btn-box" style="width: auto;">
          <button class="search" @click="getGoodsList">筛选</button>
          <!-- <button class="reset" @click="reset">重置</button> -->
        </div>
      </div>
      <el-table
        :data="goodsList"
        class="table no-border-table"
        ref="table"
        height="400"
        :header-cell-style="{
          border: 'none',
          color: '#333',
          background: '#f6f6f6',
          borderBottom: '1px solid #E8E8E8',
          height: '54px',
        }"
        :row-style="{
          height: '54px',
        }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="selectable">
        </el-table-column>
        <el-table-column
          prop="id"
          align="center"
          label="商品ID"
        ></el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="商品"
        ></el-table-column>
        <el-table-column
          prop="linePrice"
          align="center"
          label="价格"
        ></el-table-column>
        <el-table-column prop="status" align="center" label="状态">
          <div slot-scope="scope">
            {{ scope.row.status === 3 ? "出售中" : "仓库中" }}
          </div>
        </el-table-column>
        <el-table-column
          prop="totalStock"
          align="center"
          label="库存"
        ></el-table-column>
        <el-table-column
          prop="firstSortName"
          align="center"
          width="160"
          label="一级分类"
        ></el-table-column>
        <el-table-column
          prop="secondSortName"
          align="center"
          width="160"
          label="二级分类"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addGoods"
          >确定添加</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import imgUpLoader from '../../components/goods/imgUpLoader';
import Header from '../../components/common/header';
export default {
  components: { imgUpLoader, Header },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '活动详情'
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入商品名称',
            trigger: 'blur'
          },
          {
            max: 16,
            message: '商品名称不能超过十六个字',
            trigger: 'blur'
          }
        ],
        pic: [
          {
            required: true,
            message: '请选择活动图片',
            trigger: 'change'
          },
        ],
        twig: [
          {
            required: true,
            message: '请输入排序',
            trigger: 'blur'
          },
        ]
      },
      baseInfo: {

      },
      info: {
        name: '',
        pic: '',
        twig: null
      },
      filter: {
        name: '',
        partition: ''
      },
      list: [],
      id: null,
      visible: false,
      multipleSelection: [],
      categoryList: [],
      category: [],
      category2: [],
      goodsList: [],
      selectedObj: {},
      sortShow: false,
      currentSort: 0,
      gid: null,
      partition: '',
      name: '',
      businessList: [
        '主推区',
        '优选区',
        '福利区',
        '直播区'
      ],
    };
  },
  computed: {},
  async mounted() {
    let query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getGoodDetail(query.id);
      this.getList();
    }
    this.getCategoryList();
  },
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 获取商品信息
    getGoodDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getActivityList, { id }).then(
        (res) => {
          this.loading--;
          let now = (res.list && res.list[0]) ? res.list[0] : {}
          let info = { ...this.info };
          for (let key in info) {
            info[key] = now[key];
          }
          this.info = { ...info };
          this.id = now.id;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取分类列表
    getCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getGoodsCategoryList, {}).then(
        (res) => {
          this.loading--;
          this.categoryList = res.list.filter((item) => item.second.length);
          this.categoryList.unshift({
            name: '全部',
            id: 0
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getGoodsList(){
      this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: 1,
        size: 9999,
        firstSortId: this.category[0] || 0,
        secondSortId: this.category[1] || 0,
        name: this.name,
        partition: this.partition,
        status: '1,3'
      }).then(
        (res) => {
          this.loading--;
          this.goodsList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 取消
    handleCancel() {
      this.$router.push({ name: 'goodsManage' });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectable(row, index){
      if(this.selectedObj[row.id]) {
        return false
      } else {
        return true
      };
    },
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.info, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    },
    // 添加商品
    addActivity() {
      // 请求数据
      let inputData = {
        ...this.info
      };
      // 是否为编辑商品
      if (this.id) {
        inputData.id = this.id;
      }
      this.loading++;
      this.httpPost(
        this.$root.updateActivity, // 添加商品 or 创建商品
        inputData
      ).then(
        (res) => {
          this.$message({
            message: this.id ? '修改修改成功' : '修改创建成功',
            type: 'success'
          });
          this.loading--;
          if(res.id){
            this.$router.replace({
              path: 'add-activity-goods',
              query: {
                id: res.id,
                type: 'edit'
              }
            });
            this.id = res.id;
            this.getGoodDetail(res.id);
          }
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getList(){
      this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: 1,
        size: 9999,
        activity: this.id,
        ...this.filter,
        firstSortId: this.category2[0] || 0,
        secondSortId: this.category2[1] || 0,
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    search(){
      this.getList();
    },
    reset(){
      this.filter = {
        name: '',
        partition: ''
      };
      this.category2 = [];
      this.getList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    disassociationActivity(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要取消关联吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.disassociationActivity, {
          aid: this.id,
          gid: id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    selectGoods(){
      this.category = [];
      this.goodsList = [];
      let obj = {};
      this.list.forEach(item => {
        obj[item.id] = true;
      });
      this.selectedObj = obj;
      this.visible = true;
    },
    addGoods(){
      console.log(this.multipleSelection);
      this.loading++;
      this.httpPost(this.$root.associationActivity, {
        mapList: this.multipleSelection.map(item => {
          return {
            gid: item.id,
            aid: this.id
          }
        })
      }).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.visible = false;
          this.getList();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeSortModal(twig, gid) {
      this.currentSort = twig;
      this.gid = gid;
      this.sortShow = true;
    },
    saveSort() {
      this.loading++;
        this.httpPut(this.$root.updateActivityTwig, {
          aid: this.id,
          gid: this.gid,
          twig: +this.currentSort
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.sortShow = false;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 24px 20px;
      border-radius: 2px;

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }

        .addImg {
          .tips {
            // margin-bottom: 12px;
            line-height: 40px;
          }

          .icon {
            width: 270px;
            height: 108px;
          }

          .img {
            width: 270px;
            height: auto;
          }

          p {
            margin: 0;
          }

          .tip {
            color: gray9;
          }
          .file{
            width: 270px;
            height: 100%;
          }
        }

        .base-info-form {
          margin-left: 90px;
        }

        .good-input {
          width: 620px;
        }

        .btn{
          width: 128px;
          height: 32px;
          border-radius: 4px;
          word(14, #fff);
          flex-x(center);
          background: #FF7E90;
          cursor: pointer;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }

        .red {
          color: red;
        }

        .option-box {
          background: #F7F8FA;
          padding: 0 24px;
          border-radius: 2px;
          border: 1px solid #E8E8E8;
          // height: 32px;
          overflow: hidden;

          .option-item {
            flex-x(flex-start);
            height: 40px;

            &.option-head {
              height: 32px;
            }

            input {
              height: 32px;
              background: #fff;
              border: 1px solid #E8E8E8;
              box-sizing: border-box;
            }

            .cell1 {
              width: 330px;

              input {
                width: 310px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }

            .cell2 {
              input {
                width: 500px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }
          }

          .option-btn {
            width: 94px;
            height: 32px;
            border: 1px solid #E8E8E8;
            box-sizing: border-box;
            background: #fff;
            flex-x(center);
            font-size: 14px;
            border-radius: 2px;
            cursor: pointer;
            margin-top: 12px;
            margin-bottom: 16px;
          }
        }

        .filter-box{
          padding-left: 20px;
          flex-x();
          .btn-box{
            width: auto;}
          .search{
            min-width: 65px;
            width: auto;
            padding: 0 12px;
          }
        }

        .row{
          flex-x(flex-start);
          .item{
            height: 66px;
            flex-x(flex-start);
            .label{
              width: 200px;
              margin-right: 36px;
              text-align: right;
            }
          }
        }
      }

      .good-specs-box {
        .good-specs {
          // padding: 20px;
          // border: 1px solid gray9;
          margin: 30px 70px 0 60px;
        }
      }

      .remarks {
        width: 100%;
        padding-left: 95px;
        box-sizing: border-box;

        .remarks-input {
          max-width: 600px;

          textarea {
            font-size: 14px;
            max-width: 600px;
          }
        }

        .good-detail {
          padding-left: 82px;
        }
      }

      .good-detail {
        padding-bottom: 50px;
      }
    }
  }

  .table-btn {
    width: 65px;
    height: 24px;
    line-height: 24px;
    color: gray3;
    font-size: 12px;
    margin-right: 8px;
    cancel-btn();
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
